import {
    TbHexagonLetterAFilled,
    TbHexagonLetterBFilled,
    TbHexagonLetterCFilled,
    TbHexagonLetterDFilled,
    TbHexagonLetterFFilled,
  } from "react-icons/tb";
  
  const GradeIcon = ({ grade, className = "text-2xl" }) => {
    const baseClass = `inline mx-1 ${className}`;
  
    switch (grade) {
      case "A":
        return <TbHexagonLetterAFilled className={`${baseClass} text-[#4bba76]`} />;
      case "B":
        return <TbHexagonLetterBFilled className={`${baseClass} text-[#ffb147]`} />;
      case "C":
        return <TbHexagonLetterCFilled className={`${baseClass} text-[#fb7a4f]`} />;
      case "D":
        return <TbHexagonLetterDFilled className={`${baseClass} text-[#f32e43]`} />;
      default:
        return <TbHexagonLetterFFilled className={`${baseClass} text-[#b81143]`} />;
    }
  };
  
  export default GradeIcon;
  